// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Drawer } from '@iheartjane/reefer';
import { mediaQueries } from '@iheartjane/reefer-emotion';

export const DrawerFooter = styled(Drawer.Footer)<{ fixedFooter?: boolean }>(
  ({ fixedFooter }) => ({
    width: '100%',
    ...(fixedFooter
      ? {
          [mediaQueries.desktop('sm', 'max')]: {
            position: 'sticky',
            bottom: 0,
            zIndex: 1,
          },
        }
      : {}),
  })
);
